import React from "react";
import "./SliderFilter.scss";

import ArrowButton from "../ArrowButton/ArrowButton";

// Using a local version that is modified to fix issue with slide width calculation
import Slider from '../../vendor/react-slick/src';

import {connectCurrentRefinements} from "react-instantsearch-dom";
import ClearSelection from "../ClearSelection/ClearSelection";
const ClearRefinementsAlgolia = connectCurrentRefinements(ClearSelection);


const includes = (arr, elArray) => {
  if (!arr) {
    return false;
  }

  if (elArray.length === 1) {
    return arr.includes(elArray[0]);
  }

  return elArray.reduce((acc, el) => acc || arr.includes(el), false);
};

const SliderFilter = TileComponent => ({ label, attribute, items, allItems, refine, onChange }) => {
  let availableItems = items && items.map(i => i.label);
  let selectedItems = items && items.filter(i => i.isRefined).map(i => i.label);
  const valueByName = c => items.find(i => i.label === c).value;

  // Putting this here as ModalFilter.defaultProps does not work with HOC?
  label = label || "No label";
  allItems = allItems || [];
  availableItems = availableItems || [];
  selectedItems = selectedItems || [];
  ////////////

  const getBPsettingsArray = () => {

    const getBPsettings = (bp, count) => { 
      return {
        breakpoint: bp,
        settings: {
          slidesToShow: count,
          slidesToScroll: count,
        }
      }
    }

    if(label === "Colour") {
      return [
        getBPsettings(1000, 14),
        getBPsettings(850, 10),
        getBPsettings(620, 6)
      ]
    } else {
      return [
        getBPsettings(1100, 10),
        getBPsettings(980, 8),
        getBPsettings(790, 7),
        getBPsettings(680, 6),
      ];
    }
  }


  const sliderSettings = {
    slidesToShow: label === "Colour" ? 17 : 12,
    slidesToScroll: label === "Colour" ? 17 : 12,
    infinite: false,
    swipeToSlide: false,
    draggable: false,
    nextArrow: <ArrowButton direction="next" />,
    prevArrow: <ArrowButton direction="prev"/>,
    responsive: getBPsettingsArray()
  }

  const className = `slider-filter slider-filter--${label.toLowerCase()}`

  return (
    <div className={className}>
      <div className="slider-filter__header">
        <h6>{label}</h6>
        { selectedItems.length > 0 && <span className="slider-filter__selected-text">{selectedItems.length} of {allItems.length} selected</span>}
        {/* { selectedItems.length === 0 && (<span className="mobile-filter__selected-text">Showing all {label.toLowerCase()}s</span>)} */}
        { selectedItems.length > 0 && <ClearRefinementsAlgolia attr={attribute}  />}
      </div>
      <Slider {...sliderSettings}>
        {allItems &&
          allItems.map(_c => {
            const c = Array.isArray(_c) ? _c : [_c];

            const selected = includes(selectedItems, c);
            const disabled = !!(availableItems && !includes(availableItems, c));
            return (
              <TileComponent
                key={c[0]}
                name={c[0]}
                disabled={disabled}
                selected={selected}
                onClick={() => {
                  if (!disabled) {
                    c.forEach(cc => { refine(valueByName(cc)); });
                    if (onChange) {
                      if (includes(selectedItems, c)) {
                        const selectedItemsCopy = [...selectedItems];
                        selectedItemsCopy.splice(selectedItems.indexOf(c[0]), 1);
                        onChange(selectedItemsCopy);
                      } else {
                        onChange([...selectedItems, c[0]]);
                      }
                    }
                  }
                }}
              />
            );
          })}
      </Slider>
    </div>
  );
};

export default SliderFilter;